/** Historical conflict counts by year (UCDP data 1946-2024) */
export interface YearData {
  year: number;
  stateBased: number;
  nonState: number;
  oneSided: number;
  totalDeaths: number;
}

// Sourced from UCDP annual reports and PRIO Conflict Trends
export const timelineData: YearData[] = [
  { year: 1946, stateBased: 17, nonState: 0, oneSided: 0, totalDeaths: 300000 },
  { year: 1950, stateBased: 13, nonState: 0, oneSided: 0, totalDeaths: 500000 },
  { year: 1955, stateBased: 15, nonState: 0, oneSided: 0, totalDeaths: 150000 },
  { year: 1960, stateBased: 14, nonState: 0, oneSided: 0, totalDeaths: 100000 },
  { year: 1965, stateBased: 23, nonState: 0, oneSided: 0, totalDeaths: 200000 },
  { year: 1970, stateBased: 30, nonState: 0, oneSided: 0, totalDeaths: 120000 },
  { year: 1975, stateBased: 35, nonState: 0, oneSided: 0, totalDeaths: 160000 },
  { year: 1978, stateBased: 36, nonState: 0, oneSided: 0, totalDeaths: 170000 },
  { year: 1980, stateBased: 37, nonState: 0, oneSided: 0, totalDeaths: 200000 },
  { year: 1982, stateBased: 39, nonState: 0, oneSided: 0, totalDeaths: 180000 },
  { year: 1984, stateBased: 41, nonState: 0, oneSided: 0, totalDeaths: 160000 },
  { year: 1986, stateBased: 43, nonState: 0, oneSided: 0, totalDeaths: 170000 },
  { year: 1988, stateBased: 44, nonState: 0, oneSided: 0, totalDeaths: 150000 },
  { year: 1989, stateBased: 43, nonState: 28, oneSided: 19, totalDeaths: 130000 },
  { year: 1990, stateBased: 48, nonState: 34, oneSided: 21, totalDeaths: 140000 },
  { year: 1991, stateBased: 51, nonState: 38, oneSided: 25, totalDeaths: 150000 },
  { year: 1992, stateBased: 52, nonState: 41, oneSided: 27, totalDeaths: 180000 },
  { year: 1993, stateBased: 47, nonState: 32, oneSided: 22, totalDeaths: 120000 },
  { year: 1994, stateBased: 44, nonState: 38, oneSided: 30, totalDeaths: 700000 },
  { year: 1995, stateBased: 39, nonState: 31, oneSided: 18, totalDeaths: 90000 },
  { year: 1996, stateBased: 38, nonState: 33, oneSided: 15, totalDeaths: 80000 },
  { year: 1997, stateBased: 36, nonState: 29, oneSided: 13, totalDeaths: 60000 },
  { year: 1998, stateBased: 37, nonState: 30, oneSided: 16, totalDeaths: 85000 },
  { year: 1999, stateBased: 37, nonState: 31, oneSided: 20, totalDeaths: 75000 },
  { year: 2000, stateBased: 35, nonState: 28, oneSided: 17, totalDeaths: 60000 },
  { year: 2001, stateBased: 34, nonState: 26, oneSided: 20, totalDeaths: 55000 },
  { year: 2002, stateBased: 31, nonState: 25, oneSided: 15, totalDeaths: 40000 },
  { year: 2003, stateBased: 30, nonState: 24, oneSided: 14, totalDeaths: 45000 },
  { year: 2004, stateBased: 31, nonState: 26, oneSided: 18, totalDeaths: 40000 },
  { year: 2005, stateBased: 32, nonState: 27, oneSided: 16, totalDeaths: 35000 },
  { year: 2006, stateBased: 33, nonState: 28, oneSided: 18, totalDeaths: 55000 },
  { year: 2007, stateBased: 35, nonState: 30, oneSided: 17, totalDeaths: 50000 },
  { year: 2008, stateBased: 37, nonState: 33, oneSided: 19, totalDeaths: 60000 },
  { year: 2009, stateBased: 36, nonState: 31, oneSided: 18, totalDeaths: 55000 },
  { year: 2010, stateBased: 31, nonState: 25, oneSided: 15, totalDeaths: 35000 },
  { year: 2011, stateBased: 37, nonState: 38, oneSided: 20, totalDeaths: 50000 },
  { year: 2012, stateBased: 32, nonState: 39, oneSided: 22, totalDeaths: 60000 },
  { year: 2013, stateBased: 34, nonState: 43, oneSided: 24, totalDeaths: 80000 },
  { year: 2014, stateBased: 41, nonState: 52, oneSided: 30, totalDeaths: 130000 },
  { year: 2015, stateBased: 52, nonState: 62, oneSided: 35, totalDeaths: 120000 },
  { year: 2016, stateBased: 53, nonState: 62, oneSided: 34, totalDeaths: 105000 },
  { year: 2017, stateBased: 49, nonState: 62, oneSided: 32, totalDeaths: 90000 },
  { year: 2018, stateBased: 52, nonState: 70, oneSided: 35, totalDeaths: 80000 },
  { year: 2019, stateBased: 54, nonState: 68, oneSided: 37, totalDeaths: 75000 },
  { year: 2020, stateBased: 56, nonState: 63, oneSided: 38, totalDeaths: 80000 },
  { year: 2021, stateBased: 55, nonState: 70, oneSided: 40, totalDeaths: 120000 },
  { year: 2022, stateBased: 55, nonState: 77, oneSided: 42, totalDeaths: 205000 },
  { year: 2023, stateBased: 59, nonState: 76, oneSided: 45, totalDeaths: 165000 },
  { year: 2024, stateBased: 61, nonState: 74, oneSided: 49, totalDeaths: 160000 },
];
